<div class="calendar-wrapper">
    <kendo-scheduler *ngIf="showCalendar" #scheduler [slotClass]="getSlotClass" [kendoSchedulerBinding]="events" [workWeekStart]="1"
        [workWeekEnd]="5" [workDayStart]="startTime" [workDayEnd]="endTime" (dateChange)="onDateChange($event)"
        [selectedViewIndex]="selectedViewIndex" (selectedViewIndexChange)="onViewIndexChange($event)"
        [selectedDate]="selectedDate" [loading]="loading" [group]="group" [resources]="resources"
        (eventClick)="onEventClick($event)">
        <ng-template kendoSchedulerToolbarTemplate let-selectedDate="selectedDate">
            <app-calendar-header class="custom-calendar-toolbar" [selectedDate]="selectedDate"
                [selectedViewIndex]="selectedViewIndex" (viewChange)="onViewIndexChange($event)"
                (dateChange)="onDateChange({selectedDate: $event})">
            </app-calendar-header>
        </ng-template>
        <ng-template kendoSchedulerGroupHeaderTemplate let-resource="resource">
            <div class="employee-group-header">
                <kendo-badge class="ml-8 employee-name" position="none" size="large" rounded="full" themeColor="none"
                    [style.backgroundColor]="resource?.color" [style.color]="'white'">
                    {{resource?.text || ''}}
                </kendo-badge>
                <span class="employee-city-state">{{ resource?.cityState || '-' }}</span>
                <span *ngIf="resource?.phone" class="employee-city-state">{{ resource?.phone | phoneFormat : "US"}}</span>
                <div class="employee-certifications" *ngIf="resource?.certifications?.length">
                    <div *ngFor="let cert of resource.certifications" class="certification-item">{{ cert }}</div>
                </div>
                <span class="employee-distance"
                    *ngIf="formatDistance(resource?.distance) || formatDuration(resource?.duration)">
                    {{formatDistance(resource?.distance)}}
                    <span *ngIf="formatDistance(resource?.distance) && formatDuration(resource?.duration)"> • </span>
                    {{formatDuration(resource?.duration)}}
                </span>
            </div>
        </ng-template>
        <ng-template kendoSchedulerEventTemplate let-event="event">
            <div class="event-month-view">
                <span class="blue-dot"><i class="fa-solid fa-circle"></i></span>
                <span class="start-time">{{event?.start | date: "hh:mm a"}}</span>
                <span class="event-title">{{event?.title || '-'}}</span>
            </div>
        </ng-template>
        <kendo-scheduler-timeline-view #timeline [startTime]="startTime" [endTime]="endTime">
        </kendo-scheduler-timeline-view>
        <kendo-scheduler-multi-week-view [numberOfWeeks]="2">
        </kendo-scheduler-multi-week-view>
        <kendo-scheduler-month-view></kendo-scheduler-month-view>
        <kendo-scheduler-timeline-week-view [startTime]="startTime" [endTime]="endTime">
        </kendo-scheduler-timeline-week-view>
    </kendo-scheduler>
</div>
